import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { DateField, TimeField } from "@/components/common/DateField";

// Compact labeled field used across admin editors.
// type="date" renders the shared DateField (DD/MM/YYYY mask + calendar, emits ISO).
// type="time" renders the shared TimeField (24h HH:MM).
export const Field = ({ label, value, onChange, type = "text", textarea = false, placeholder, testid, minDate, maxDate, disableFuture }) => (
  <div>
    <Label className="mb-1 block text-xs font-medium text-gmoaa-text-muted">{label}</Label>
    {type === "date" ? (
      <DateField value={value} onChange={onChange} placeholder={placeholder} testid={testid} minDate={minDate} maxDate={maxDate} disableFuture={disableFuture} />
    ) : type === "time" ? (
      <TimeField value={value} onChange={onChange} testid={testid} />
    ) : textarea ? (
      <Textarea data-testid={testid} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="border-gmoaa-border-subtle bg-white" rows={3} />
    ) : (
      <Input data-testid={testid} type={type} value={value ?? ""} onChange={(e) => onChange(type === "number" ? Number(e.target.value) : e.target.value)} placeholder={placeholder} className="border-gmoaa-border-subtle bg-white" />
    )}
  </div>
);
